import React, {PropTypes} from 'react';

class ScreenInstructions extends React.Component {
    constructor(props) {
        super(props);
    }

       render() {
        return (
                <div className="o-pageSection o-pageSection--instructions">
                    <h3 className="c-InstructionTitle">{this.props.title}</h3>
                    <p className="c-BodyText">{this.props.text}</p>
                </div>                
            );
        }
}



ScreenInstructions.propTypes = {
    title: React.PropTypes.string.isRequired,
    text: React.PropTypes.string.isRequired
};


export default ScreenInstructions;


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Subcomponents/ScreenInstructions.js
 **/